import { ButtonList, DropdownButton } from '@dixa/lib-shared-habla';
import { ArticleDataContext } from 'articleEditor/contexts/articleDataProvider';
import useArticleEditorBackLink from 'articleEditor/hooks/useArticleEditorBackLink';
import { ArticleDeleteModal } from 'collection/pages/collectionEdit/components/modals/articleDeleteModal';
import { useModal } from 'lib-knowledge-modal';
import { useContext } from 'react';
import { useNavigate } from 'react-router-dom';

import s from './headerControls.module.scss';
import TimeAgo from './timeAgo';

export const ActionsDropdown = (): JSX.Element => {
  const { showModal } = useModal();
  const navigate = useNavigate();
  const { to } = useArticleEditorBackLink();
  const article = useContext(ArticleDataContext);
  if (!article) return <></>;

  const deleteArticle = () =>
    showModal(ArticleDeleteModal, {
      articleId: article.id,
      onDelete: () => navigate(to),
    });

  return (
    <DropdownButton
      noArrow
      icon="dots-h"
      dropdown={
        <ButtonList>
          <ButtonList.Item
            buttonClassName={s.buttonWarning}
            className={s.buttonWarning}
            icon="trash"
            onClick={deleteArticle}
          >
            Permanently delete
          </ButtonList.Item>

          <ButtonList.Divider />
          {article.updatedAt && article.updatedBy && (
            <TimeAgo
              labelPrefix="Last edited by"
              at={article.updatedAt}
              by={article.updatedBy}
            />
          )}
        </ButtonList>
      }
    ></DropdownButton>
  );
};
